import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ConfigModalProps } from "./types";
import { ConfigurationTabs } from "./ConfigurationTabs";

export const ConfigModal: React.FC<ConfigModalProps> = ({ open, onClose, onSubmit }) => {
  const handleClose = () => {
    onClose();
  };

  const handleRefresh = () => {
    onSubmit();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          Moderation Configuration
          <IconButton onClick={handleClose} edge="end">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <ConfigurationTabs onRefresh={handleRefresh} />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
